import DrugSearchBar from 'screens/FactsScreen/components/drugSearchBar/DrugSearchBar';
import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';
import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

const DrugPortfolioManagementHoc = () => {
  const {
    DrugPortfolioManagementStore: { resetStore },
  } = useStore();

  useEffect(() => {
    // Cleanup function will be called when component unmounts
    return () => {
      resetStore();
    };
  }, [resetStore]);

  return (
    <div>
      <Navbar heading="Drug Portfolio Management" searchComponent={<DrugSearchBar />} />
      <Outlet />
    </div>
  );
};

export default DrugPortfolioManagementHoc;
